import { helper } from '@ember/component/helper';

export function textAsLines([text]) {
  return text?.split('\n').filter((line) => line);
}

export default helper(textAsLines);
